export enum Role {
  ROLE_ORGANIZATION_USER_GROUP_EDIT = 'ROLE_ORGANIZATION_USER_GROUP_EDIT',
  ROLE_ORGANIZATION_USER_GROUP_DELETE = 'ROLE_ORGANIZATION_USER_GROUP_DELETE',
  ROLE_CLIENT_FILTER_EDIT = 'ROLE_CLIENT_FILTER_EDIT',
  ROLE_CLIENT_FILTER_DELETE = 'ROLE_CLIENT_FILTER_DELETE',
  ROLE_HUB_EDIT = 'ROLE_HUB_EDIT',
  ROLE_HUB_DELETE = 'ROLE_HUB_DELETE',
  ROLE_CAR_EDIT = 'ROLE_CAR_EDIT',
  ROLE_CAR_DELETE = 'ROLE_CAR_DELETE',
  ROLE_CAR_BATTERY_EVENT_EDIT = 'ROLE_CAR_BATTERY_EVENT_EDIT',
  ROLE_CAR_BATTERY_EVENT_DELETE = 'ROLE_CAR_BATTERY_EVENT_DELETE',
  ROLE_SITE_EDIT = 'ROLE_SITE_EDIT',
  ROLE_SITE_DELETE = 'ROLE_SITE_DELETE',
  ROLE_COMPANY_EDIT = 'ROLE_COMPANY_EDIT',
  ROLE_USER_EDIT = 'ROLE_USER_EDIT',
  ROLE_USER_DELETE = 'ROLE_USER_DELETE',
  ROLE_HUB_LOG = 'ROLE_HUB_LOG',
  ROLE_SYS = 'ROLE_SYS',
  ROLE_DISTRIBUTOR = 'ROLE_DISTRIBUTOR',
  ROLE_DISTRIBUTOR_ADMIN = 'ROLE_DISTRIBUTOR_ADMIN',
}
